export default function FilterBtn({
  text,
  handleClick,
  filterType,
  allFilters,
}) {
  return (
    <button
      key={filterType}
      className={allFilters.includes(filterType) ? "active" : ""}
      onClick={() => handleClick({ filterType })}
    >
      {text}
    </button>
  );
}
